import { STEP_VALIDATION } from './constants';

const initialState = {
  step: STEP_VALIDATION
};

export default initialState;
